export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const setPrefixToObjectProperties = (prefix: string, datas: object) =>
  Object.entries(datas).reduce(
    (finalObject: object, [key, value]) => ({
      ...finalObject,
      [`${prefix}${capitalizeFirstLetter(key)}`]: value,
    }),
    {}
  );
